import { useFormikContext } from "formik";
import RadioButton, { Props } from "../RadioButton/RadioButton";

export default function FormRadioButton({ onChange, ...props }: Props) {
  const { handleChange } = useFormikContext();

  return (
    <RadioButton
      {...props}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        handleChange(e);
        onChange?.(e);
      }}
    />
  );
}
